// extracted by mini-css-extract-plugin
export default {"productCarousel":"m0-z"};